export default {
    name: "image-preview",
    props: {
        imgSrc: String,
    },
    data() {
        return {
            hdImage: this.imgSrc.replaceAll("_thumb", "_hd"),
        };
    },
    mounted() {},
    methods: {
        onClose(event) {
            event.stopPropagation();
            this.$emit("previewClose");
        },
    },
};
